<div *ngIf="loading && type == 'spinner'" [style.width.px]="diameter" [style.height.px]="diameter" [style.font-size.px]="diameter-2" style="margin:0;color:orangered;" class="k-i-loading"></div>
